import React from "react";
/* import ChatAssistant from "./ChatAssistant"; */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faEnvelope,
  faLocationDot,
  // faAngleUp,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

import WhatsAppWidget from "react-whatsapp-chat-widget";
import "react-whatsapp-chat-widget/index.css";
const Footer = () => {
  return (
    <>
      <footer>
        <div className="container">
          <div className="row justify-content-center py-4">
            {/* Logo Section */}
            <div className="col-md-4 ps-4 mx-auto text-center">
              <span className="">
                
                <img
                  src="/assets/aarda.png" //Arda İçin Logo gerekli
                  className="img-fluid px-0 logo-text"
                  alt="Ali Arda Gül Hukuk Bürosu"
                  width="1000"
                  height="200"
                />
              </span>
              
              <p className="content pt-3 px-3">
             Hukuk büromuz, haklarınızı en iyi şekilde koruyarak size kapsamlı rehberlik sağlar ve ihtiyaçlarınızı en iyi şekilde belirleyerek hukuki uyumunuzu gerçekleştirir.

              </p>

              <p className="content pt-3 px-3">
              Ulaşılabilirlik, şeffaflık ve profesyonellik ilkelerine bağlı kalarak, hukuki ilişkilerinizin titizlikle düzenlenmesi ve tarafı olduğunuz uyuşmazlıkların hak kaybı riskine mahal vermeden etkin bir şekilde çözülmesi için hizmet sunmaktayız.
              </p>


              
            </div>

            {/* Contact Section */}
            <div className="col-md-4 text-center">
              <h6 className="pb-2">İletişim</h6>
              <div className="d-flex align-items-center justify-content-center flex-column">
                <span className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="contact-icon"
                    title="av.aliardagul@gmail.com"
                  />                  
                  <span className="fw-light px-2">av.aliardagul@gmail.com  </span>
                </span>

                <a href="mailto:av.aliardagul@gmail.com?subject=Danışmanlık%20Talebi&body=Merhaba%20Avukat%20Ali%20Arda,%0A%0AAdım:%20[Adınızı%20Yazınız]%0A%0ATelefon%20Numaram:%20[Telefon%20Numaranızı%20Yazınız]%0A%0ABir%20danışmanlık%20talebim%20var.%0A%0ATeşekkür%20ederim."
   className="email-link">
   E-Posta Gönder
</a>
              </div>
              <div className="mt-3 d-flex align-items-center justify-content-center flex-column">
                <span className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon={faPhone}
                    className="contact-icon"
                    title="+90 541 316 96 21"
                  />
                   <a href="tel:+90 543 882 20 92" style={{ textDecoration: 'none', color: 'inherit' }}>
                   +90 543 882 20 92  
</a>
                </span>
              </div>
              <div className="mt-3 d-flex align-items-center justify-content-center flex-column">
                <span className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="contact-icon"
                    title="Ankara"
                  />
                  <br></br>
                  <br></br>
                
                
                  <span className="px-2 fw-light">Ankara Türkiye</span>
                  
                </span>
                <br></br>
               
                
                <iframe className="mt-3"

               
  src=" https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.8351510156267!2d32.850663075841176!3d39.90032297152735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34f758b7ee3e7%3A0x29f4457c5b1afb95!2sAyranc%C4%B1%2C%20Kuveyt%20Cd.%20No%3A28%20D%3A5%2C%2006540%20%C3%87ankaya%2FAnkara!5e0!3m2!1str!2str!4v1725613214355!5m2!1str!2str" 
  width="320" 
  height="320" 
  style={{border: 0}} 
  allowFullScreen="" 
  loading="lazy" 
  referrerPolicy="no-referrer-when-downgrade"
  title="Konum Haritası"
/>

              </div>
            </div>

            {/* Program section */}
            <div className="col-md-4 text-center mt-4 mt-md-0">
              <div>
                <h6 className="pb-2">Çalışma Saatleri</h6>
                <p className="fw-light">
                Pazartesi – Cumartesi: 09.00 – 18.00 <br /> Pazar: Kapalı
                </p>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
               
                
                
                
                
               
                <p>Çalışma saatleri içerisinde her türlü hukuki sorununuzla ilgili bize danışabilir, bilgi alabilirsiniz.  </p>
                <p>İletişim sayfamızdaki formu kullanarak veya bizimle telefon, WhatsApp, e-posta yoluyla iletişime geçerek randevu oluşturabilirsiniz. </p>
                <p>Acil hukuki destek talepleriniz için her an telefonla bize ulaşabilirsiniz.
                </p>
            
            


                


               
              </div>
            </div>
          </div>
        </div>

        {/* Scroll up */}
        {/* <div>
          <a
            href="#top"
            aria-label="Navigheaza in partea de sus"
            className="scroll-to-top"
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              })
            }
          >
            <FontAwesomeIcon icon={faAngleUp} className="up-icon" size="2x" />
          </a>
        </div> */}
        {/* WhatsAppWidget */}
       {/*  <ChatAssistant /> */}
        <div>
          <WhatsAppWidget
            phoneNo="+905438822092"
            position="right"
            iconSize="50"
            iconColor="white"
            iconBgColor="#25D366"
            headerIcon="/assets/LOGO2.png"
            
            headerTxtColor="white"
            headerBgColor="#02182b"
            headerTitle="Hukuk Bürosu"
            headerCaption="Çevrimiçi"
            bodyBgColor="#bbb"
            chatPersonName="Destek"
            chatMessage={
              <>
                Merhaba,
                <br />
                <br />Size nasıl yardımcı olabiliriz?
              </>
            }
            footerBgColor="#999"
            btnBgColor="#c2b697"
            btnTxtColor="black"
          />
        </div>
        
        {/* Copyright */}
        <div>
          <div className="bg-dark d-flex align-items-center justify-content-center">
            <hr></hr>
            <p className="copyright mb-0">©2024 Avukat Ali Arda Gül</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
